import { apiClient, type ApiEnvelope } from './client';
import type { AuthUser, AuthTenant, Persona } from '@/shared/stores/auth';

export interface LoginPayload {
  email: string;
  password: string;
  device_name?: string;
}

export interface LoginResult {
  token: string;
  persona: Persona;
  user: AuthUser;
}

export async function login(payload: LoginPayload): Promise<LoginResult> {
  const { data } = await apiClient.post<ApiEnvelope<LoginResult>>('/auth/login', payload);

  if (!data.success || !data.data) {
    throw new Error(data.message ?? 'Login failed');
  }

  return data.data;
}

export interface MeResult {
  user: AuthUser;
  tenant: AuthTenant | null;
}

export async function me(persona: Persona): Promise<MeResult> {
  const path = persona === 'super' ? '/super/me' : `/${persona}/me`;
  const { data } = await apiClient.get<ApiEnvelope<MeResult>>(path);

  if (!data.success || !data.data) {
    throw new Error(data.message ?? 'Failed to load profile');
  }

  return data.data;
}

export async function logout(persona: Persona): Promise<void> {
  const path = persona === 'super' ? '/super/logout' : `/${persona}/logout`;

  try {
    await apiClient.post(path);
  } catch {
    // best-effort; even on failure the client should clear its local token
  }
}
